// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import { CacheProvider } from '@emotion/react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import CustomTheme from './assets/CustomTheme'; // ✅ use your defined theme
import cacheRtl from './utils/createEmotionCache';

document.body.dir = 'rtl'; // optional

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <CacheProvider value={cacheRtl}>
            <ThemeProvider theme={CustomTheme}>
                <CssBaseline />
                <App />
            </ThemeProvider>
        </CacheProvider>
    </React.StrictMode>
);
